var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-form-item',{attrs:{"label":_vm.label,"for":_vm.id,"prop":_vm.id}},[_c('el-select',_vm._b({attrs:{"id":_vm.id,"value":_vm.value},on:{"change":_vm.change,"input":_vm.input}},'el-select',_vm.$attrs,false),_vm._l((_vm.options),function(option){return _c('el-option',{key:option.id,attrs:{"label":option.label,"value":option.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }